import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
import { computed, observable, runInAction } from "mobx";
import { realCommerceRequest, __ } from "../utils";
import { routeLocationPaddleProductPlanGet } from "@devowl-wp/api-real-commerce";
import { RealCommerceError } from "../exceptions";
import { localizePaymentInterval } from "../others";
import { EProductPlanPaymentInterval } from "@devowl-wp/api-real-commerce";
let Product = (_class = class Product {
  get websiteCount() {
    var _this$data$productPla, _this$data$productPla2;
    return +(((_this$data$productPla = this.data.productPlan.description) === null || _this$data$productPla === void 0 ? void 0 : (_this$data$productPla2 = _this$data$productPla.match(/(\d+)+ website/i)) === null || _this$data$productPla2 === void 0 ? void 0 : _this$data$productPla2[1]) || 0);
  }
  get isOneTime() {
    return this.data.productPlan.paymentInterval === EProductPlanPaymentInterval.OneTime;
  }
  get labelPaymentInterval() {
    if (!this.data) {
      return "";
    }
    return localizePaymentInterval(this.data.productPlan.paymentInterval);
  }

  // @TODO: dynamically get from REST API and move to product model
  get seller() {
    return {
      name: "Paddle.com",
      link: __("https://paddle.com"),
      terms: __("https://paddle.com/legal-buyers"),
      privacy: __("https://paddle.com/privacy-buyers")
    };
  }

  // @TODO: dynamically get from REST API and move to product model
  get manufacturer() {
    return {
      name: "devowl.io GmbH",
      link: __("https://devowl.io/"),
      terms: __("https://devowl.io/terms/"),
      cancellation: __("https://devowl.io/cancellation-policy/"),
      privacy: __("https://devowl.io/privacy-policy/"),
      support: __("https://devowl.io/support/"),
      supportDpa: __("https://devowl.io/dpa-support/")
    };
  }
  constructor(data, store) {
    _initializerDefineProperty(this, "data", _descriptor, this);
    this.store = void 0;
    this.store = store;
    runInAction(() => {
      this.data = data;
    });
  }

  /**
   * Load the backend data from backend.
   *
   * @param params
   * @param store
   */
  static async loadProduct(params, store) {
    let result;
    try {
      result = await realCommerceRequest({
        location: routeLocationPaddleProductPlanGet,
        params
      });
    } catch (e) {
      throw new RealCommerceError(e);
    }
    return new Product(result, store);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "data", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "websiteCount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "websiteCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOneTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOneTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "labelPaymentInterval", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "labelPaymentInterval"), _class.prototype)), _class);
export { Product };